var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"src":"/xlsx-style/index.html","id":"base-excel-style-export"}})
}
var staticRenderFns = []

export { render, staticRenderFns }